// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
   baseApi: '/dumalbaceteback',
  // baseApi: 'https://duminaldes.grupotecopy.es/dumalbaceteback',
  // baseApi: 'http://localhost:8080/dumalbaceteback',
  nominatim_server: {
    baseUrl: 'https://nominatim.openstreetmap.org',
  },
  max_size_page_tables: 10,
  base_url_osrm: 'https://router.project-osrm.org/route/v1/driving/',
  language_json: '/assets/i18n/',
  accepts_type_images: '.jpg, .jpeg, .png',
  accepts_type_documents: '.jpg, .jpeg, .pdf',
  time_panel_control: 120000,
  time_real_map: 5000,
  default_width_map: '500px',
  default_height_map: '500px',
  default_lat_map: 41.65518,
  default_lon_map: -4.72372,
  capa_barrios:
    'https://www10.ava.es/arcgisva/rest/services/Divisiones_administrativas/Barrios_y_Subzonas/MapServer/0/query?where=OBJECTID+%3E+0&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&having=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&f=pjson',
  base_url_esri_10_ava_calles:
    'https://www10.ava.es/arcgisva/rest/services/CallejeroVA/base/MapServer/12/query',
  base_url_esri_10_ava_portales:
    'https://www10.ava.es/arcgisva/rest/services/CallejeroVA/base/MapServer/18/query',
  img_default_news: '/assets/imagenes/news_default.jpg',
  img_n_serie: '/assets/imagenes/nserie.jpg',
  logo_emisalba: '/assets/imagenes/logo-emisalba.png',
  logo_albapark: '/assets/imagenes/EMISALBA-favicon.png',
  logo_duminval_footer: '/assets/imagenes/EMISALBA-footer.png',
  endPoints: {
    users: {
      users: '/users',
      login: '/dologin',
      me: '/me',
      logout: '/logout',
      restorePassword: '/restorePassword',
      updatePassword: '/updatePassword',
      updateMePassword: '/updateMePassword',
      deny: '/deny',
      creditcard: '/creditcard',
      approve: '/approve',
      busqueda: '/busqueda',
    },
    roles: {
      roles: '/roles',
    },
    noticia: {
      noticias: '/noticias',
      destacadas: '/destacadas',
    },
    maestras: {
      base_maestra: '/maestras',
      estadoPlaza: '/estados',
      tipoPlaza: '/tipoplaza',
      sector: '/sectores',
      distrito: '/distritos',
      tipoAparcamiento: '/aparcamientos',
      barrio: '/barrios',
      subBarrio: '/subbarrios',
      distintivoAmbiental: '/distintivos',
      tipoVehiculo: '/tipovehiculo',
      tipoPlazaVehiculo: '/tipoplaza/vehiculos',
      tipoCombustible: '/tipocombustible',
      estadoSolicitud: '/estadosolicitud',
      usoVehiculo: '/usovehiculo',
      temaAlerta: '/temaalerta',
      temaContacto: '/temacontacto',
      tipoDocumento: '/tipodocumento',
    },
    plazas: {
      base_plazas: '/plazas',
      busquedaPlazas: '/busquedaPlaza',
      codigoQR: '/codigoQR',
      sinregulacion: '/sinregulacion',
      tipoPlaza: '/tipoplaza',
      ids: '/ids',
    },
    vehiculos: {
      base_vehiculos: '/vehiculos',
      matricula: '/matricula',
      me: '/me',
      busquedaVehiculos: '/busquedavehiculo',
      aprobacionVehiculo: '/aprobarsolicitud',
      denegarVehiculo: '/denegarsolicitud',
    },
    bicicletas: {
      base_bicicletas: '/bicicletas',
      propietario: '/propietario',
      me: '/me',
    },
    usuarioAutorizado: {
      base_usuarioAutorizado: '/autorizacion',
      vehiculoAutorizadoUsuario: '/usuario',
      vehiculoAutorizadoVehiculo: '/vehiculos',
      autorizadosVehiculos: '/vehiculo',
      autorizadoVehiculosAut: '/autorizados',
      me: '/me',
    },
    regulacionPlaza: {
      base_regulacionPlaza: '/regulacion',
      plaza: '/plaza',
      busqueda: '/busquedaregulacion',
      tipoplaza: '/tipoplaza',
    },
    sesionEstacionamiento: {
      base_sesionEstacionamiento: '/sesionestacionamiento',
      usuario: '/usuario',
      regulacion: '/regulacion',
      vehiculo: '/vehiculo',
      me: '/me',
      panelControl: '/panelcontrol',
      busqueda: '/busquedasesion',
      cerrarSesion: '/cerrarsesion',
    },
    historicoSesionEstacionamiento: {
      base_historicoSesionEstacionamiento: '/historicoestacionamientos',
      sesion: '/sesion',
      usuario: '/usuario',
      regulacion: '/regulacion',
      vehiculo: '/vehiculo',
      plaza: '/plaza',
      barrio: '/barrio',
      distrito: '/distrito',
      tipoPlaza: '/tipoPlaza',
      tipoVehiculo: '/tipovehiculo',
      sector: '/sector',
      tipoCombustible: '/tipocombustible',
      distintivoAmbiental: '/distintivo',
      fecha: '/fechas',
      duracion: '/duracion',
      peso: '/pma',
      matricula: '/matricula',
      usoPlaza: '/usoplaza',
      me: '/me',
      busqueda: '/busqueda',
      informe: '/informe',
      exportar: '/exportar',
      csv: '/csv',
      json: '/json',
      xml: '/xml',
      geojson: '/geojson',
    },
    contactoSoporte: {
      base_contactoSoporte: '/contactosoporte',
      temaContacto: '/temacontacto',
      usuario: '/usuario',
      me: '/me',
    },
    sugerencia: {
      base_sugerencia: '/sugerencia',
    },
    ruta: {
      base_ruta: '/ruta',
      me: '/me',
    },
    alerta: {
      base_alerta: '/alerta',
      temaAlerta: '/temaalerta',
      sesion: '/sesion',
      regulacion: '/regulacion',
      busqueda: '/busquedaalertas',
    },
    documento: {
      base_documento: '/documentos',
      vehiculo: '/vehiculo',
      nombre: '/nombre',
      me: '/me',
      aprobado: '/approve',
      denegado: '/deny',
      imagenes: '/imagenes',
    },
    zonas_vigilancia: {
      base_zona_vigilancia: '/zonasvigilancia',
    },
  },
  roles: {
    administradores: 'ADMINISTRADOR',
    supervisores: 'SUPERVISOR',
    controladores: 'CONTROLADOR',
    analistas: 'ANALISTA',
    usuarios: 'USUARIO',
  },
  estados_plaza: {
    DISPONIBLE: '611510a73988f62605e718df',
    OCUPADA: '611510a73988f62605e718e0',
    NO_DISPONIBLE: '611510a73988f62605e718e1',
    ALARMA_ACTIVA: '611510a73988f62605e718e2'
  },
  estado_solicitud: {
    PENDIENTE: '611510a93988f62605e718f3',
    APROBADA: '611510a93988f62605e718f4',
    DENEGADA: '611510a93988f62605e718f5'
  },
  icon_map: {
    cluster: '/assets/imagenes/iconos/marker-counter-m.png',
    CyD: {
      red: '/assets/imagenes/iconos/CyDRed.png',
      green: '/assets/imagenes/iconos/CyDGreen.png',
      blue: '/assets/imagenes/iconos/CyDBlue.png',
      black: '/assets/imagenes/iconos/CyDBlack.png',
      yellow: '/assets/imagenes/iconos/CyDYellow.png',
      default: '/assets/imagenes/iconos/CyDDefault.png'
    },
    PMR: {
      red: '/assets/imagenes/iconos/PMRRed.png',
      green: '/assets/imagenes/iconos/PMRGreen.png',
      blue: '/assets/imagenes/iconos/PMRBlue.png',
      black: '/assets/imagenes/iconos/PMRBlack.png',
      yellow: '/assets/imagenes/iconos/PMRYellow.png',
      default: '/assets/imagenes/iconos/icon_PMR_default.png',
    },
    VE: {
      red: '/assets/imagenes/iconos/VERed.png',
      green: '/assets/imagenes/iconos/VEGreen.png',
      blue: '/assets/imagenes/iconos/VEBlue.png',
      black: '/assets/imagenes/iconos/VEBlack.png',
      yellow: '/assets/imagenes/iconos/VEYellow.png',
      default: '/assets/imagenes/iconos/VEDefault.png'
    },
  },
  icon_rutas: {
    icon_origen: '/assets/imagenes/iconos/flag_origin.png',
    icon_destino: '/assets/imagenes/iconos/flag_destiny.png',
  },
  calendar_locale: {
    es: {
      firstDayOfWeek: 1,
      dayNames: [
        'domingo',
        'lunes',
        'martes',
        'miércoles',
        'jueves',
        'viernes',
        'sábado',
      ],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
      ],
      monthNamesShort: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic',
      ],
      today: 'Hoy',
      clear: 'Borrar',
    },
  },
  const: {
    _id: '_id',
  },
  enlaces_interes: {
    admin_super: [
      {
        url: 'area-privada/lista-usuarios',
        textoUrl: 'ENLACES.INTERES.GESTIONAR.USUARIOS',
        descripcion: 'ENLACES.INTERES.GESTIONAR.USUARIOS.MSG',
      },
      {
        url: 'area-privada/registro-usuario',
        textoUrl: 'ENLACES.INTERES.REGISTRAR.USUARIOS',
        descripcion: 'ENLACES.INTERES.REGISTRAR.USUARIOS.MSG',
      },
      {
        url: 'area-privada/vehiculos',
        textoUrl: 'ENLACES.INTERES.GESTIONAR.VEHICULOS',
        descripcion: 'ENLACES.INTERES.GESTIONAR.VEHICULOS.MSG',
      },
      {
        url: 'area-privada/infraccion-alertas',
        textoUrl: 'ENLACES.INTERES.VISUALIZAR.ALERTAS.INFRACCION',
        descripcion: 'ENLACES.INTERES.VISUALIZAR.ALERTAS.INGRACCION.MSG',
      },
      {
        url: 'area-privada/lista-plazas',
        textoUrl: 'GLOBAL.PLAZAS',
        descripcion: 'ENLACES.INTERES.PLAZAS.MSG',
      },
      {
        url: 'area-privada/alertas',
        textoUrl: 'ENLACES.INTERES.VISUALIZAR.ALERTAS',
        descripcion: 'ENLACES.INTERES.ALERTAS.MSG',
      },
    ],
    controlador: [
      {
        url: 'area-privada/lista-regulacion-plazas',
        textoUrl: 'ENLACE.INTERES.REGULACION.PLAZA',
        descripcion: 'ENLACE.INTERES.REGULACION.PLAZA.MSG',
      },
      {
        url: 'area-privada/alertas',
        textoUrl: 'ENLACES.INTERES.VISUALIZAR.ALERTAS',
        descripcion: 'ENLACES.INTERES.ALERTAS.MSG',
      },
    ],
    analista: [
      {
        url: 'area-privada/analisis-uso-plazas',
        textoUrl: 'ENLACES.INTERES.VISUALIZAR.ANALISIS.USO.PLAZA',
        descripcion: 'ENLACES.INTERES.VISUALIZAR.ANALISIS.USO.PLAZA.MSG',
      },
      {
        url: 'area-privada/consulta-sesion-estacionamiento',
        textoUrl: 'ENLACE.INTERES.VISUALIZAR.SESIONES.ESTACIONAMIENTO',
        descripcion: 'ENLACE.INTERES.VISUALIZAR.SESIONES.ESTACIONAMIENTO.MSG',
      },
      {
        url: 'area-privada/panel-control-tiempo-real',
        textoUrl: 'ENLACE.INTERES.VISUALIZAR.PANEL.CONTROL',
        descripcion: 'ENLACE.INTERES.VISUALIZAR.PANEL.CONTROL.MSG',
      },
    ],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
